import { AgResourceLanguage } from '../types';
import { login as EnUsLogin } from '../en-us/login';

export const login: AgResourceLanguage['login'] = {
  ...EnUsLogin,
  header: 'Fel e-postadress eller lösenord',
  description:
    'Se till att detta är samma e-postadress som du använde när du lade din beställning eller skapade ditt konto.'
};
